/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from "react";
import { InputLabel, Popover, makeStyles } from "@material-ui/core";
import { useField } from "formik";
import { ChromePicker } from "react-color";

const useStyles = makeStyles(() => ({
  label: {
    fontSize: "0.8rem",
    marginBottom: ".5rem"
  },
  color: {
    width: "36px",
    height: "14px",
    borderRadius: "2px",
    background: field => field.value
  },
  swatch: {
    padding: "5px",
    background: "#fff",
    borderRadius: "1px",
    boxShadow: "0 0 0 1px rgba(0,0,0,.1)",
    display: "inline-block",
    cursor: "pointer"
  }
}));

const ColorPickerField = ({ name, label, large = false, ...other }) => {
  const [field, meta, { setValue }] = useField(name);
  const isInError = Boolean(meta.touched) && Boolean(meta.error);
  const classes = useStyles(field);
  const [anchorEl, setAnchorEl] = useState(null);
  return large ? (
    <div>
      <InputLabel className={classes.label}>{label}</InputLabel>
      <ChromePicker
        color={field.value || "#3c8bbb"}
        margin="normal"
        error={isInError}
        helperText={isInError && meta.error}
        {...field}
        {...other}
        onChange={color => {
          setValue(color.hex);
        }}
        onChangeComplete={color => {
          setValue(color.hex);
          setAnchorEl(null);
        }}
      />
    </div>
  ) : (
    <>
      <InputLabel className={classes.label}>{label}</InputLabel>
      <div className={classes.swatch} onClick={e => setAnchorEl(e.currentTarget)}>
        <div className={classes.color} />
      </div>
      <Popover open={Boolean(anchorEl)} anchorEl={anchorEl} onClose={() => setAnchorEl(null)}>
        <ChromePicker
          color={field.value}
          margin="normal"
          error={isInError}
          helperText={isInError && meta.error}
          {...field}
          {...other}
          onChange={color => {
            setValue(color.hex);
          }}
          onChangeComplete={color => {
            setValue(color.hex);
            setAnchorEl(null);
          }}
        />
      </Popover>
    </>
  );
};

export default ColorPickerField;
